import { createAction } from '@reduxjs/toolkit'
import { FilterTableParams } from './types'

export const updateHideAssetsFlag = createAction<boolean>(
  'assets/updateHideAssetsFlag',
)

export const updateTableParams = createAction<{
  key: keyof FilterTableParams
  value: string | boolean
}>('assets/updateTableParams')
